export type Unsubscribe = () => void;

export class EventBus<TEvent> {
  private readonly listeners = new Set<(event: TEvent) => void>();

  subscribe(listener: (event: TEvent) => void): Unsubscribe {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }

  emit(event: TEvent): void {
    for (const listener of this.listeners) {
      listener(event);
    }
  }

  clear(): void {
    this.listeners.clear();
  }
}